export default "__VITE_ASSET__CwsQX4rA__"